import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { CharacterEditor } from './views/CharacterEditor';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<CharacterEditor />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.CharacterEditor)
	.build();

export default Layout;
